import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from '../components/Button';
import Icon from '../components/Icon';
import PropertyListed from '../components/PropertyListed';
import PropertyCard from '../components/PropertyCard';
import {byProperty, toggleScroll} from '../lib/utils';
import styled, { css } from 'styled-components';

const scrolledStyles = `
  > div:first-child {
      background-color: #333;
      height: 40px;
      transform: translateY(28px);
    > div {
      top: 10px;
      right: 115px;
      @media (min-width: 1600px) {
        & {
          right: 50%;
          transform: translateX(675px);
        }
      }
    }
    > button {
      color: #fff;
      width: 70px;
      border-radius: 0;
      right: 16px;
      text-align: right;
      position: absolute;
      z-index: 9;
      top: auto;
      background-color: transparent;
      @media (min-width: 1600px) {
        & {
          right: 50%;
          transform: translateX(780px);
        }
      }
      span {
        left: -20px;
        position: absolute;
        text-transform: uppercase;
        font-size: 0.825em;
      }
      i {
        width: 20px;
        height: 20px;
      }
    }
  }
`

const StyledFilter = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => props.active ? "100%" : "0"};
  overflow: visible;
  z-index: 5;
  &::before {
    opacity: ${props => props.active ? ".5" : "0"};
    position: fixed;
    pointer-events:none;
    content: "";
    height: 100vh;
    width: 100vw;
    background-color: rgba(255, 255, 255, 1);
    top: 0;
    left: 0;
    z-index: 1;
    -webkit-transition: opacity .4s ease-in-out;
    -moz-transition: opacity .4s ease-in-out;
    -o-transition: opacity .4s ease-in-out;
    transition: opacity .4s ease-in-out;
  }
  > div {
    /* OffCanvas Toggle Button */
    &:first-child {
      background-color: transparent;
      -webkit-transition: all .4s ease-in-out;
      -moz-transition: all .4s ease-in-out;
      -o-transition: all .4s ease-in-out;
      transition: all .4s ease-in-out;
      position: fixed;
      height: 60px;
      transform: translateY(120px);
      left: 0;
      width: 100%;
      z-index: 2;
      > div {
        color: ${props => props.theme.white};
        background: ${props => props.theme.blueBright};
        font-size: 10px;
        line-height: 18px;
        text-align: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        pointer-events: none;
        position: absolute;
        right: 85px;
        top: 45px;
        z-index: 2;
        @media (min-width: 1600px) {
          right: 50%;
          transform: translateX(720px);
        }
      }
      > button {
        background-color: #333;
        border-radius: 12px;
        color: ${props => props.theme.blueBright};
        display: inline-block;
        height: 100%;
        overflow: visible;
        width: 80px;
        -webkit-transition: all .4s ease-in-out;
        -moz-transition: all .4s ease-in-out;
        -o-transition: all .4s ease-in-out;
        transition: all .4s ease-in-out;
        position: absolute;
        top: 0px;
        z-index: 1;
        right: 16px;
        @media (min-width: 1600px) {
          right: 50%;
          transform: translateX(785px);
        }
        i {
          margin: 0 auto;
          width: 30px;
          height: 30px;
          transform: rotate(90deg);
          -webkit-transition: all .4s ease-in-out;
          -moz-transition: all .4s ease-in-out;
          -o-transition: all .4s ease-in-out;
          transition: all .4s ease-in-out;
        }
        span {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: calc(100% + 10px);
          font-size: 11px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
      }
    }
    /* OffCanvas Area */
    &:nth-child(2) {
      position: fixed;
      top: ${props => props.scrolled ? "30px" : "90px"};
      width: 90%;
      right: 0;
      transform: ${props => props.active ? "translateX(0vw)" : "translateX(100vw)"};
      background: #333;
      height: ${props => props.scrolled ? "calc(100% - 30px)" : "calc(100% - 90px)"};
      overflow-x: hidden;
      overflow-y: auto;
      white-space: nowrap;
      z-index: 2;
      -webkit-transition: transform .4s ease-in-out;
      -moz-transition: transform .4s ease-in-out;
      -o-transition: transform .4s ease-in-out;
      transition: transform .4s ease-in-out;
      padding: 32px 0;
      text-align: left;
      @media (min-width: 340px) {
        top: ${props => props.scrolled ? "30px" : "105px"};
        height: ${props => props.scrolled ? "calc(100% - 30px)" : "calc(100% - 105px)"};
      }
      @media (min-width: 375px) {
        width: 75%;
      }
      @media (min-width: 768px) {
        width: 61%;
      }
      @media (min-width: 1280px) {
        width: 51%;
      }
      /* OffCanvas Levels */
      > div {
        position: relative;
        display: inline-block;
        white-space: normal;
        left: 10;
        transform: ${props => props.adding ? "translateX(-100%)" : "translateX(0vw)"};
        width: 100%;
        padding: 0 8px 60px;
        vertical-align: top;
        -webkit-transition: transform .4s ease-in-out;
        -moz-transition: transform .4s ease-in-out;
        -o-transition: transform .4s ease-in-out;
        transition: transform .4s ease-in-out;
        @media (min-width: 375px) {
          padding: 0 16px 60px;
        }
        /* OffCanvas Levels Header */
        > div:first-child {
          margin-bottom: 32px;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-align-items: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: start;
          -webkit-justify-content: space-between;
          -ms-flex-pack: space-between;
          justify-content: space-between;
          button {
            background: transparent;
            padding: 0;
            i {
              height: 40px;
              width: 40px;
              border-radius: 20px;
              text-align: center;
              svg {
                height: 14px;
                width: 14px;
                margin: 13px auto 0 auto;
              }
            }
            /* Add */
            &:first-child {
              i {
                background-color: #21A0D2;
                margin: 0 1em;
              }
            }
            /* Reset */
            &:nth-child(2):not(:last-child) {
              opacity: .5;
              top: 40px;
              left: 50%;
              transform: translateX(-50%);
              opacity: .5;
              position: absolute;
              i {
                height: 20px;
                width: 20px;
                border-radius: 0;
                margin: 0;
                svg {
                  height: 10px;
                  width: 10px;
                  margin: 5px 0 0 0;
                }
              }
              span {
                padding: 0; margin: 0;
              }
              @media (min-width: 640px) {
                top: 10px;
              }
            }
            /* Close */
            &:last-child {
              flex-direction: row-reverse;
              i {
                background-color: #444;
                margin: 0 1em;
              }
            }
            span {
              text-transform: uppercase;
              font-size: .825em;
            }
          }
        }
        /* OffCanvas Levels Content */
        > div:last-child {
          > span {
            color: #bbb;
            margin: 40px 16px 24px;
            font-size: .625em;
            letter-spacing: 1px;
            position: relative;
            text-transform: uppercase;
            display: block;
            &:first-of-type {
              margin-top: 0;
            }
            i {
              margin: -2px 8px;
              opacity: .4;
              svg {
                stroke: #bbb;
              }
            }
          }
        }
      }
    }
    /* APPLY BTN */
    &:last-child {
      position: fixed;
      width: 90%;
      right: 0;
      z-index: 10;
      bottom: 0;
      padding: 24px;
      transform: ${props => props.adding ? "translateX(0vw)" : "translateX(100vw)"};
      -webkit-transition: transform .4s ease-in-out;
      -moz-transition: transform .4s ease-in-out;
      -o-transition: transform .4s ease-in-out;
      transition: transform .4s ease-in-out;
      background: linear-gradient(to bottom, rgba(51, 51, 51, 0), #333 20%);
      > button {
        margin: 0 auto;
        width: 100%;
        max-width: 200px;
        justify-content: center;
      }
      @media (min-width: 375px) {
        width: 75%;
      }
      @media (min-width: 768px) {
        width: 61%;
      }
      @media (min-width: 1280px) {
        width: 51%;
      }
    }
  }
  & {
    ${props => props.scrolled ? css`${scrolledStyles}` : ''}
  }
`;
export default function Filter (props) {
  const {properties, setAdded, added, count, products, selection, setFilter, toggleProducts, scrolled} = props;
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [selected, setSelected] = useState(added);

  const toggle = (e) => {
    if(e.pageX < e.currentTarget.children[1].offsetLeft){
      setOpen(false);
      setAdding(false);
    }
  }

  const toggleProp = (key) => {
    const curr = [selected.indexOf(key) > -1
      ? null
      : key,
        ...selected.filter(item => item !== key)
    ].filter(item => item);
    setSelected(curr);
  }

  const removeProp = (key) => {
    const curr = added.filter(item => item !== key);
    setSelected(curr);
    setAdded(curr);
  }

  const scrollUp = () => {
    document.getElementsByClassName("offcanvas")[0].scrollTop = 0;
  }

  useEffect(() => {
    if(!mounted && !open && properties.length > 0) {
      setMounted(true);
      //setOpen(true);
    }
  }, [open, mounted, properties, adding]);

  useEffect(() => {
    toggleScroll(!open);
  }, [open]);

  const currProps = properties.slice().sort(byProperty("label"))

  return (
    <StyledFilter active={open} adding={adding} scrolled={scrolled} onClick={!!open ? (e) => toggle(e) : null}>
      <div>
        <Button icon="filter" onClick={() => setOpen(!open)} label={"Filter"}/>
        {!!count &&
          <div>{count}</div>
        }
      </div>
      <div className="offcanvas" >
        {/* Set Property Values */}
        <div>
          <div>
            <Button icon="plus" label="add filter" onClick={() => setAdding(!adding)}/>
            {!!count &&
            <Button icon="minus" label="reset all values" onClick={() => {setFilter();}}/>
            }
            <Button icon="collapse" label="close" onClick={() => setOpen(!open)}/>
          </div>
          <div>
          {!!products.length &&
            <PropertyCard
              data={{label: "Manual selection", max: products.length}}
              apply={selection ? null : () => toggleProducts(products)}
              toggle={() => {toggleProducts(); setOpen(!open);}}
            />
          }
          {added.reduce((acc, curr) => [...acc, ...properties.filter(prop => prop.key === curr)],[]).map((item, index) =>
            <PropertyCard key={index} data={item} removeProp={removeProp} setFilter={setFilter} />
          )}
          </div>
        </div>
        {/* Add Properties */}
        <div>
          <div>
            <Button icon="left" label="back" onClick={() => setAdding(false)}/>
            <Button icon="collapse" label="close" onClick={() => {setOpen(false); setAdding(false);}}/>
          </div>
          <div>
            <span>Physicochemical attributes <Icon name="physical"/></span>
          {currProps.filter(item => item.type === "physical").map((item, index) =>
            <PropertyListed key={index} toggle={toggleProp} data={item} selected={selected.indexOf(item.key) > -1}/>
          )}
            <span>Sensory attributes <Icon name="sensory"/></span>
          {currProps.filter(item => item.type === "sensory").map((item, index) =>
            <PropertyListed key={index} toggle={toggleProp} data={item} selected={selected.indexOf(item.key) > -1}/>
          )}
          </div>
        </div>
      </div>
      <div>
      {adding &&
        <Button label="Apply" medium rounded blueBright onClick={() => {setAdded(selected); setAdding(false); scrollUp();}}/>
      }
      </div>
    </StyledFilter>)
}

Filter.propTypes = {
  open: PropTypes.bool,
  products: PropTypes.array,
  toggleProducts: PropTypes.func,
  onToggle: PropTypes.func
}
